const colors = {
  grey: {
    50: '#FBFCFE',
    100: '#F0F4F8',
    200: '#DDE7EE',
    300: '#CDD7E1',
    400: '#9FA6AD',
    500: '#636B74',
    600: '#555E68',
    700: '#32383E',
    800: '#171A1C',
    900: '#0B0D0E'
  },
  blue: {
    50: '#EDF5FD',
    100: '#E3EFFB',
    200: '#C7DFF7',
    300: '#97C3F0',
    400: '#4393E4',
    500: '#0B6BCB',
    600: '#185EA5',
    700: '#12467B',
    800: '#0A2744',
    900: '#051423'
  },
  yellow: {
    50: '#FEFAF6',
    100: '#FDF0E1',
    200: '#FCE1C2',
    300: '#F3C896',
    400: '#EA9A3E',
    500: '#9A5B13',
    600: '#72430D',
    700: '#492B08',
    800: '#2E1B05',
    900: '#1D1002'
  },
  red: {
    50: '#FEF6F6',
    100: '#FCE4E4',
    200: '#F7C5C5',
    300: '#F09898',
    400: '#E47474',
    500: '#C41C1C',
    600: '#A51818',
    700: '#7D1212',
    800: '#430A0A',
    900: '#240505'
  },
  green: {
    50: '#F6FEF6',
    100: '#E3FBE3',
    200: '#C7F7C7',
    300: '#A1E8A1',
    400: '#51BC51',
    500: '#1F7A1F',
    600: '#136C13',
    700: '#0A470A',
    800: '#042F04',
    900: '#021D02'
  }
};
export default colors;